export const CLASSIC_CHAT_PATH = "/chat";
export const CHAT_WORKSPACE_PATH = "/chat-workspace";

const ALLOWED_PRIMARY_APP_PATHS = new Set([
  CLASSIC_CHAT_PATH,
  CHAT_WORKSPACE_PATH,
]);

export const primaryAppPath = (globals = globalThis?.window?.globals) => {
  const candidate = globals?.primary_app_path;
  return ALLOWED_PRIMARY_APP_PATHS.has(candidate)
    ? candidate
    : CLASSIC_CHAT_PATH;
};

export const primaryAppLocation = ({ search = "", hash = "" } = {}) => ({
  pathname: primaryAppPath(),
  search,
  hash,
});
